import { useHttpClient } from "../http-client";
import { useSupervisorMode } from "../../components/supervisor-mode-provider";
import { useQuery } from "@tanstack/react-query";
import { ApiOrganizationDetails } from "../types/api-organization-details";

export const useGetOrganizationDetailsApi = (params: {
  organizationId: string;
}) => {
  const httpClient = useHttpClient();
  const isSupervisor = useSupervisorMode();

  const getDetails = async ({
    signal,
  }: {
    signal: AbortSignal;
  }): Promise<ApiOrganizationDetails> => {
    const response = await httpClient.get(
      `/classifier/organizations/${params.organizationId}`,
      {
        params: {
          supervisor: isSupervisor,
        },
        signal,
      }
    );
    return response.data.data;
  };

  return useQuery({
    queryKey: ["organizationDetails", params.organizationId, isSupervisor],
    queryFn: getDetails,
    staleTime: Infinity,
  });
};
